import React from 'react';

import { RiDraggable } from 'react-icons/ri';
import { FiMoreVertical } from 'react-icons/fi';

import { CSS } from '@dnd-kit/utilities';
import { useSortable } from '@dnd-kit/sortable';

import { TYPE_ATTRIBUTES } from 'constants/linkLibrary';

import PopOver from 'components/common/popover';
import { LinkLibraryLinkRow } from 'interface/linkLibraryTree';

interface PopperData {
  styles: Record<string, string | number>;
}

interface Props {
  rowData: LinkLibraryLinkRow;
  activePopoverId: string | null;
  setActivePopoverId: React.Dispatch<React.SetStateAction<string | null>>;
}

export const DraggableLinkTableRow: React.FC<Props> = ({ rowData, activePopoverId, setActivePopoverId }) => {
  const { transform, transition, attributes, setNodeRef, listeners } = useSortable({
    id: rowData.id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const typeAttributes = TYPE_ATTRIBUTES[rowData.type as keyof typeof TYPE_ATTRIBUTES];
  const popoverId = `link-${rowData.id}`;

  return (
    <tr ref={setNodeRef} style={style}>
      <td>
        <div {...attributes} {...listeners} className="rst__row-draggableIcon">
          <RiDraggable />
        </div>
      </td>
      <td className="link-table-name">
        <div className={typeAttributes.titleClass}>{rowData.name}</div>
      </td>
      <td className="link-table-url">
        <div>
          <a
            href={rowData.linkUrl}
            target="_blank"
            onClick={(event) => {
              event.stopPropagation();
            }}
            rel="noreferrer"
          >
            {rowData.linkUrl}
          </a>
        </div>
      </td>
      <td>
        <span
          className="vertical-ellipsis"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <PopOver
            interactive
            theme="light"
            open={activePopoverId === popoverId}
            onRequestClose={() => setActivePopoverId(null)}
            size="small"
            position="left-start"
            distance={5}
            disableOnScroll={true}
            popperOptions={{
              modifiers: {
                addZIndex: {
                  enabled: true,
                  order: 810,
                  fn: (data: PopperData) => ({
                    ...data,
                    styles: {
                      ...data.styles,
                      zIndex: 10,
                    },
                  }),
                },
              },
            }}
            html={typeAttributes.html(rowData, undefined, popoverId, setActivePopoverId)}
            className="vertical-ellipsis__menu dots-menu"
          >
            <FiMoreVertical
              className="grey--text"
              size={24}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setActivePopoverId(activePopoverId === popoverId ? null : popoverId);
              }}
            />
          </PopOver>
        </span>
      </td>
    </tr>
  );
};
